<template>
  <div class="achievement">
    <div class="tab">
      <span :class="activeTab==1?'activeTab':''"
            @click="tab(1)">会议</span>
      <span :class="activeTab==2?'activeTab':''"
            @click="tab(2)">单课</span>
    </div>
    <div class="search">
      <!-- completeType -->
      <div class="searchLet"
           @click.stop="'null'">
        <span @click="serchM">{{completeName}}</span>
        <i @click="serchM"></i>
        <ul class="serchList"
            v-show="visList">
          <li :class="completeType==0?'activeLi':''"
              @click="serchBnt({id:0,name:'全部作业'})">全部作业</li>
          <li :class="completeType==1?'activeLi':''"
              @click="serchBnt({id:1,name:'已完成'})">已完成</li>
          <li :class="completeType==2?'activeLi':''"
              @click="serchBnt({id:2,name:'未完成'})">未完成</li>
        </ul>
      </div>
      <div class="search_inp">
        <input type="text"
               placeholder="请输入课程名称"
               v-model="keyWord" />
        <div @click="toMore()"
             class="searchBnt"></div>
      </div>
    </div>
    <div class="carList">
      <template v-if="activeTab==1">
        <div class="item"
             v-for="(item,index) in list"
             :key="index">
          <div class="item-title"
               @click="listShow(item)">
            <span>{{item.colTitle}}</span>
            <i></i>
          </div>
          <ul class="item-child"
              v-show="itemId == item.colId"
              v-if="item.rels">
            <li v-for="(el,idx) in item.rels"
                :key="idx"
                @click="goPage(el.relId)">
              {{el.title}}
              <i></i>
            </li>
            <!-- <li>血筛检测试剂盒在欧洲、美国和其他国他国…<i></i></li>
                    <li>血筛检测试剂盒在欧洲、美国和其他国他国…<i></i></li>
            <li>血筛检测试剂盒在欧洲、美国和其他国他国…<i></i></li>-->
          </ul>
        </div>
      </template>
      <template v-else>
        <div class="item"
             v-for="(item,index) in certificateList"
             :key="index">
          <div class="item-title"
               @click="showSub(item, index)">
            <span>{{item.egName}}</span>
            <i></i>
          </div>
          <div v-show="item.open">
            <div class="item-menu">
              <span class="activeMenu">全部</span>
              <span v-for="level in lList"
                    :key="level.dictId">{{level.dictName}}</span>
            </div>
            <ul class="item-child">
              <li v-for="live in item.lives"
                  :key="live.lId"
                  style="display:flex;"
                  @click="goPage(live.lId)">
                <span class="item-level">【{{live.levelName}}】</span>
                <span>{{live.lTitle}}</span>
                <i :class="{complete: item.workType != 0}"></i>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      keyWord: "",
      list: [],
      lList: [],
      certificateList: [],
      activeTab: 1,
      itemId: 1,
      completeName: "全部作业",
      completeType: "0",
      visList: false,
      wxuser: null
    };
  },
  props: {},
  async mounted () {
    this.  wxuser=await loginService.getLoginUser();
    document.title = "作业列表";
    // this.$postHttp(AppSetting.baseUrl + '/student/complete/video',{uid:this.wxuser.uId,}).then((res)=>{
    //   if(res.data.code==0){
    //     this.video_hottest = res.data.list;
    //   }
    // })
    this.getList();
    this.getLevelList();
  },
  methods: {
    showSub (item, index) {
      item.open = !item.open;
      this.$set(this.certificateList, index, item)
    },
    listShow (item) {
      if (item.colId == this.itemId) {
        this.itemId = "";
      } else {
        this.itemId = item.colId;
      }
    },
    serchM () {
      this.visList = !this.visList;
    },
    serchBnt (val) {
      this.completeType = val.id;
      this.completeName = val.name;
      this.toMore();
    },
    tab (val) {
      this.activeTab = val;
      if (val == 1) {
        this.getList();
      } else {
        this.getList1();
      }
    },
    toMore () {
      this.visList = false;
      if (this.activeTab == 1) {
        this.getList();
      } else {
        this.getList1();
      }
    },
    goPage (id, type) {
      this.$router.push({
        name: "Answer",
        query: {
          id: id,
          type: 'video'
        }
      });
    },
    getList () {
      let param = {
        uid: this.wxuser.uId,
        name: this.keyWord,
        completeType: this.completeType
      };
      this.$postHttp(AppSetting.baseUrl + "/question/app/columnList", param).then(res => {
        if (res.data.code == 0) {
          this.list = res.data.data;
        }
      });
    },
    getLevelList () {
      this.$postHttp(AppSetting.baseUrl + "/dictionary/app/list", {
        dictType: "LEVEL"
      }).then(res => {
        if (res.data.code == 0) {
          let data = res.data.list;
          this.lList = data;
        }
      });
    },
    getList1 () {
      let param = {
        uid: this.wxuser.uId,
        name: this.keyWord,
        completeType: this.completeType
      };
      this.$postHttp(AppSetting.baseUrl + "/question/app/videoList", param).then(res => {
        if (res.data.code == 0) {
          let data = res.data.data.map(item => {
            item.open = false;
            return item;
          });
          this.certificateList = data;
        }
      });
    }
  },
  components: {},
  computed: {}
};
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;

  .tab {
    width: 100%;
    display: flex;
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
    padding: 0px 0.3rem;
    box-sizing: border-box;
    span {
      flex: 1;
      padding: 0px 0.15rem;
      box-sizing: border-box;
    }
  }
  .activeTab {
    color: #05a2ff;
    font-size: 0.34rem;
    border-bottom: 0.01rem solid #05a2ff;
  }
  .search {
    padding: 0.33rem 0.29rem;
    box-sizing: border-box;
    // overflow: hidden;
    .searchLet {
      float: left;
      width: 25%;
      font-size: 0.3rem;
      color: #333;
      line-height: 0.7rem;
      position: relative;
      i {
        position: absolute;
        right: 0px;
        top: 50%;
        margin-top: -0.04rem;
        display: inline-block;
        width: 0.21rem;
        height: 0.09rem;
        background: url("../../assets/images/xiala2.png") no-repeat;
        background-size: 100% 100%;
      }
      .serchList {
        position: absolute;
        width: 1.8rem;
        line-height: 0.32rem;
        background: #fff;
        top: 0.7rem;
        z-index: 33;
        // padding: 0.15rem 0rem;
        box-sizing: border-box;
        box-shadow: 0.03rem 0.03rem 0.05rem 0.05rem rgba(0, 0, 0, 0.9);
        li {
          padding: 0.15rem 0.15rem;
          box-sizing: border-box;
        }
      }
      .activeLi {
        background: #ccc;
      }
    }
    .search_inp {
      font-size: 14px;
      float: left;
      height: 0.7rem;
      line-height: 0.7rem;
      width: 70%;
      position: relative;
      padding-right: 0.15rem;
      // border-radius: 0.15rem;
      box-sizing: border-box;
      // background:rgba(238,238,238,1);
      input {
        background: none;
        outline: none;
        border: none;
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 0.3rem;
        width: 98%;
        height: 90%;
        outline: none;
        border-radius: 0.15rem;
        box-sizing: border-box;
        padding: 0 0.3rem;
        background: rgba(238, 238, 238, 1);
      }
      .searchBnt {
        width: 0.38rem;
        height: 0.38rem;
        position: absolute;
        right: 0.15rem;
        top: 50%;
        margin-top: -0.19rem;
        // background: url("../../assets/images/search.png");
        background-size: 100% 100%;
      }
    }
  }
  .search::after {
    clear: both;
    display: block;
    content: "";
  }
  .carList {
    .item {
      padding-bottom: 0.12rem;
      background: #fff;
      margin-top: 0.15rem;
    }
    .item-title {
      font-size: 0.3rem;
      color: #333333;
      line-height: 1.04rem;
      background: #fff;
      padding: 0px 0.3rem;
      box-sizing: border-box;
      position: relative;
      // borde-bottom: 0.01rem solid #
      i {
        position: absolute;
        right: 0.15rem;
        top: 50%;
        width: 0.35rem;
        height: 0.2rem;
        background: url("../../assets/images/xiala.png") no-repeat;
        background-size: 100% 100%;
        margin-top: -0.1rem;
      }
    }
    .item-child {
      padding: 0rem 0.3rem;
      box-sizing: border-box;
      li {
        font-size: 0.28rem;
        color: #333;
        padding: 0px 0.23rem;
        box-sizing: border-box;
        background: #fff;
        border-radius: 0.1rem;
        box-shadow: 0 0 2px 4px #f6f6f6;
        margin-top: 0.11rem;
        line-height: 0.83rem;
        position: relative;
        text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
        white-space: nowrap; /*让文字不换行*/
        overflow: hidden; /*超出要隐藏*/
        i {
          display: inline-block;
          position: absolute;
          right: 0.15rem;
          top: 50%;
          width: 0.41rem;
          height: 0.41rem;
          background: url("../../assets/images/bianji@2x.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 50%;
          margin-top: -0.2rem;
        }
        i.complete {
          background: url("../../assets/images/wancheng.png") no-repeat;
          background-size: 100%;
        }
        .item-level {
          font-size: 0.28rem;
          color: #00a810;
        }
        .item-level2 {
          font-size: 0.28rem;
          color: #e79800;
        }
        .item-level3 {
          font-size: 0.28rem;
          color: #e10202;
        }
      }
    }
    .item-menu {
      font-size: 0.28rem;
      color: #666666;
      overflow: hidden;
      padding: 0.26rem;
      box-sizing: border-box;
      span {
        float: left;
        width: 0.96rem;
        text-align: center;
        line-height: 0.48rem;
        border: 0.01rem solid #e5e5e5;
        border-radius: 0.1rem;
        margin-right: 0.15rem;
      }
      .activeMenu {
        color: #333333;
        border: 0.01rem solid #30a1ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/TaskList.vue